import { FeatureFlagNameEnum } from "@/services/internalApiV1";
import type { RouteRecordRaw } from "vue-router";

// Flag off, the library does not exist: both routes send the teacher home.
// The user is seeded from `data-user` in `main.ts`, so the flag answers
// synchronously here.
const requireLibraryFlag = (): true | { name: "home" } =>
  useUserStore().isFeatureEnabled(FeatureFlagNameEnum.CURRICULUM_LIBRARY)
    ? true
    : { name: "home" as const };

export const curriculumRoutes: RouteRecordRaw[] = [
  {
    path: "/curriculum",
    name: "curriculum-library-index",
    component: () => import("./CurriculumLibraryPage.vue"),
    meta: {
      requiresAuth: true,
      requiresTeacher: true,
      title: "tools_meta.curriculum_library_prefix",
    },
    beforeEnter: requireLibraryFlag,
  },
  {
    path: "/curriculum/:documentId",
    name: "curriculum-library-show",
    component: () => import("./[documentId]/CurriculumLibraryDocumentPage.vue"),
    meta: {
      requiresAuth: true,
      requiresTeacher: true,
      title: "tools_meta.curriculum_library_prefix",
    },
    beforeEnter: requireLibraryFlag,
  },
];
